const routes = [
  {
    path: ':sie/medical-plan',
    name: 'studentMedicalPlan',
    props: true,
    component: () => import('@/views/student/medical-plan/Main.vue'),
  },
];

export default routes;
